import React, { useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { SpinnerCircular } from "spinners-react";

import useHttp from "../../../../hooks/useHttp";
import { SAVE_BANK_CARD } from "../../../../utils/api-ends";
import { STRIPE_PUBLIC_KEY } from "../../../../utils/generalData";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

const ChangeSavedCard = () => {
  return (
    <div className="col-md-8 mt-5">
      <Elements stripe={stripePromise}>
        <CheckoutForm amount={0} />
      </Elements>
    </div>
  );
};

export default ChangeSavedCard;

function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const { error, isLoading, sendRequests: saveCardRequest } = useHttp();
  const [successMessage, setSuccessMessage] = useState(null);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        // Include any additional collected billing details.
      },
    });

    if (result.paymentMethod) {
      const response = (data) => {
        setSuccessMessage(data.message);
      };
      saveCardRequest(
        {
          url: SAVE_BANK_CARD,
          method: "POST",
          data: {
            payment_method_id: result.paymentMethod.id,
          },
        },
        response
      );
    }
  };

  return (
    <form>
      {error?.message && (
        <Alert severity="error" className="mb-4">
          <AlertTitle>Error</AlertTitle>
          <strong>{error.message}</strong>
        </Alert>
      )}

      {error?.general && (
        <Alert severity="error" className="mb-4">
          <AlertTitle>Error</AlertTitle>
          <strong>{error.general}</strong>
        </Alert>
      )}

      {successMessage && (
        <Alert severity="success" className="mb-4">
          <AlertTitle>Success</AlertTitle>
          <strong>{successMessage}</strong>
        </Alert>
      )}

      <label>Card Number</label>
      <CardElement options={CARD_ELEMENT_OPTIONS} />

      <div className="mt-5">
        <Button disabled={!stripe} className="theme-btn" onClick={handleSubmit}>
          Submit
          {isLoading && (
            <SpinnerCircular
              size={22}
              thickness={180}
              speed={130}
              color="#fff"
              className="btn-loader"
              secondaryColor="rgba(57, 172, 127, 0.44)"
            />
          )}
        </Button>
      </div>
    </form>
  );
}
